export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="lg:w-[320px] flex-shrink-0">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-line text-background-50 text-lg"></i>
                </span>
                <span className="text-xl font-heading text-background-50">吃瓜网站</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                聚焦网红明星精品爆料，网红吃瓜吃料网每日爆料最新八卦内幕。提供国产51精品入口吃瓜爆料与网红最新爆料每日更新，满足你的独家吃瓜需求。
              </p>
            </div>

            <div className="flex flex-wrap gap-8 lg:gap-16 flex-1">
              <div>
                <h4 className="text-sm font-semibold text-background-100 mb-3">快速导航</h4>
                <div className="flex flex-col gap-2">
                  {[
                    { label: '视频爆料', href: '#media' },
                    { label: '爆料专题', href: '#index' },
                    { label: '热度榜单', href: '#ranking' },
                    { label: '精品爆料', href: '#cards' },
                    { label: '最新快讯', href: '#updates' },
                    { label: '常见问答', href: '#faq' },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      onClick={(e) => handleNavClick(e, link.href)}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-background-100 mb-3">热门话题</h4>
                <div className="flex flex-col gap-2">
                  {['网红吃瓜网站', '网红吃瓜吃料网每日爆料', '国产51精品入口吃瓜爆料', '网红最新爆料', '吃瓜爆料每日更新', '精品吃瓜内幕'].map((tag) => (
                    <span key={tag} className="text-sm text-background-400 whitespace-nowrap">{tag}</span>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold text-background-100 mb-3">合作伙伴</h4>
                <p className="text-sm text-background-500 whitespace-nowrap">—— 虚位以待 ——</p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 吃瓜网站 - 网红明星精品爆料第一站
            </p>
            <p className="text-xs text-background-600">
              本站内容仅供娱乐参考，不构成任何建议
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}